<template>
    <div class="text-center pt-2">
        Welcome To Domain Checkup system.
    </div>
</template>
<script>
export default {
  name: "home",
  components: {}
};
</script>
<style>
</style>
